/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export interface IFrequency {
  id?: string;
  treatmentCycles?: number | null;
  cycleDuration?: number | null;
  cycleDurationUnits?: string | null;
  intervalBetweenCycles?: number | null;
  intervalUnits?: string | null;
  totalTreatmentDuration?: number | null;
  totalTreatmentUnits?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
}

export const defaultValue: Readonly<IFrequency> = {
  active: false,
};
